import service from './service'
import { CONTENT_TYPE } from '@/constants'
import { useUserStoreWithOut } from '@/store/modules/user'
import { md5 } from 'js-md5'
import { getPreviewTenantAdminId } from '@/utils/previewTenant'
import { logErrorDedup } from '@/utils/tracker'

const request = (option: AxiosConfig) => {
  const { url, method, params, data, headers, responseType } = option

  const appId = '10010'
  const secret = '1748997e97beac84c197c4d21e84a911'

  const timestamp = new Date().getTime()
  const nonce = md5(Math.random().toString(36))

  const signStr = `app_id=${appId}&nonce=${nonce}&timestamp=${timestamp}&secret=${secret}`
  const sign = md5(signStr)

  const userStore = useUserStoreWithOut()
  return service
    .request({
      url: url,
      method,
      params,
      data: data,
      responseType: responseType,
      headers: {
        'Content-Type': CONTENT_TYPE,
        ['Authorization']: userStore.getToken ? `Bearer ${userStore.getToken}` : '',
        'X-Erp-Sign': sign,
        'X-Erp-Timestamp': timestamp,
        'X-Erp-Nonce': nonce,
        'X-Erp-AppId': appId,
        'X-Erp-Channel': 'web',
        'X-Erp-Platform': 'web',
        'X-Erp-Appversion': import.meta.env.VITE_APP_VERSION ?? '',
        'X-Erp-Auth': userStore.getDataAuth,
        'X-Erp-Store': userStore.getCurrentStore,
        ...(getPreviewTenantAdminId() ? { 'X-Erp-View-As': getPreviewTenantAdminId() } : {}),
        ...headers
      }
    })
    .then((res) => {
      return res
    })
    .catch((error: any) => {
      const status = error?.response?.status ?? 0
      // 网络/HTTP 层异常统一上报（超时、断网、5xx 等），一处覆盖所有页面。
      // 只记 path/status，不记请求体——里面可能有密码、验证码等敏感信息。
      //
      // 两类不上报：
      //   - 埋点自身依赖的接口，失败时会自我循环；
      //   - 401：未登录/登录过期是正常生命周期，不是故障。未登录访客打开首页就会
      //     撞一次 `/system/user_info` 401，紧接着被下面的 reset 送去登录页——
      //     这种日志纯粹是噪音，还会把真正的错误顶下去。
      if (!String(url).includes('/log/sts_token') && status !== 401) {
        logErrorDedup('api_request_error', {
          path: url,
          method,
          status,
          code: error?.code ?? '',
          error_message: error?.message ?? ''
        })
      }
      if (status === 401) {
        userStore.reset()
      }
      return Promise.reject(error)
    })
}

export default {
  get: <T = any>(option: AxiosConfig) => {
    return request({ method: 'get', ...option }) as Promise<IResponse<T>>
  },
  post: <T = any>(option: AxiosConfig) => {
    return request({ method: 'post', ...option }) as Promise<IResponse<T>>
  },
  delete: <T = any>(option: AxiosConfig) => {
    return request({ method: 'delete', ...option }) as Promise<IResponse<T>>
  },
  put: <T = any>(option: AxiosConfig) => {
    return request({ method: 'put', ...option }) as Promise<IResponse<T>>
  },
  cancelRequest: (url: string | string[]) => {
    return service.cancelRequest(url)
  },
  cancelAllRequest: () => {
    return service.cancelAllRequest()
  }
}
